import * as React from "react";
import { trackSegmentEvent } from "../../utils/analytics";
import { Button, Classes, Dialog, HTMLTable, Intent } from "@blueprintjs/core";
import { ContigStatistics } from "../../api";

function prettyContigSize(size: number): string {
  if (size === 0) {
    return "0";
  }
  if (size > 0 && size < 1e3) {
    return `${size}`;
  } else if (size > 1e3 && size <= 1e6) {
    return `${(size / 1e3).toFixed(1)} kb`;
  } else if (size > 1e6 && size <= 1e9) {
    return `${(size / 1e6).toFixed(1)} mb`;
  } else if (size > 1e9) {
    return `${(size / 1e9).toFixed(1)} gb`;
  }
  return ""; // (-) numbers
}

interface Props {
  isOpen: boolean;
  close: () => void;
  contigs: ContigStatistics[];
  genomeUuid: string;
  genomeName: string;
}

export default class ContigDetailsPopup extends React.PureComponent<Props> {
  private download = (): void => {
    trackSegmentEvent("Download Contigs", {
      genomeUuid: this.props.genomeUuid,
      genomeName: this.props.genomeName,
      context: "Genome Overview Tab",
      format: "csv",
    });
    let csv = "Contig Name,Contig Size,Contig Category\n";
    this.props.contigs.forEach((contig, idx: number) => {
      csv += `Contig ${idx + 1},${contig.length},${contig.circular ? "circular" : "linear"}\n`;
    });

    const hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = "contigs.csv";
    hiddenElement.click();
  };

  renderRows = (): React.ReactNode => {
    return this.props.contigs.map((contig, idx) => {
      return (
        <tr key={idx}>
          <td>
            <b>Contig {idx + 1}</b>
          </td>
          <td>{prettyContigSize(contig.length)}</td>
          <td>{contig.circular ? "circular" : "linear"}</td>
        </tr>
      );
    });
  };

  renderBody = (): React.ReactNode => {
    return (
      <div className={Classes.DIALOG_BODY}>
        <HTMLTable>
          <thead>
            <tr>
              <th>Contig Name</th>
              <th>Contig Size</th>
              <th>Contig Category</th>
            </tr>
          </thead>
          <tbody>{this.renderRows()}</tbody>
        </HTMLTable>
      </div>
    );
  };

  render() {
    return (
      <Dialog className="contigs-dialog" onClose={this.props.close} isOpen={this.props.isOpen}>
        {this.renderBody()}

        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button onClick={this.download}>Download</Button>
            <Button intent={Intent.PRIMARY} onClick={this.props.close}>
              Close
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}
